import React from 'react'
import { useSelector } from 'react-redux';
import { DocumentacionReclamoEfector } from './DocumentacionReclamoEfector';

export const DocumentacionIngresoEfector = () => {
    const { reclamoTomado } = useSelector((state) => state.reclamos);
    return <DocumentacionReclamoEfector solicitud={reclamoTomado} />;
}
